import { h, ref, createApp } from 'vue'
import ComCue from './index.vue'

const comCueBox = (msg: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const comCueBoxRef = ref<any>() // 保存实例化
    const elDiv = document.createElement('div')
    document.body.appendChild(elDiv)
    // 创建虚拟节点
    const app = createApp({
      render() {
        return h(ComCue, {
          ref: comCueBoxRef,
          msg,
          onSubmit: () => {
            resolve()
            setTimeout(() => {
              elDiv.remove()
            }, 500)
          },
          onClose: () => {
            setTimeout(() => {
              elDiv.remove()
              reject(new Error('移除失败'))
            }, 500)
          }
        })
      }
    })
    // 挂载容器
    app.mount(elDiv)
    // 打开弹窗
    comCueBoxRef.value!.isShow = true
  })
}

export default comCueBox
